import { memo } from 'react';
import { Box, Text, Image } from '@bonanza-social/moonlight';
import { CommunityJackpotPlayerProps } from './CommunityJackpotPlayer.types';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectIsNewLoyalty } from '@bonanza-social/status';

function CommunityJackpotPlayer({
  name,
  status: playerStatus,
  size = 'small',
  ...rest
}: CommunityJackpotPlayerProps) {
  const isNewLoyalty = useSelector(selectIsNewLoyalty);

  return (
    <Box flexDirection="row" {...rest}>
      {playerStatus ? (
        <Image
          name={`status.${playerStatus}Gem${isNewLoyalty ? '' : 'Legacy'}`}
          width={size === 'small' ? 'space-400' : 'space-600'}
          height={size === 'small' ? 'space-400' : 'space-600'}
          marginRight={size === 'small' ? 'space-100' : 'space-200'}
        />
      ) : null}
      <Text
        variant={size === 'small' ? 'body-s' : 'h6'}
        color="darkSurfacePrimary"
      >
        {name}
      </Text>
    </Box>
  );
}

export default memo(CommunityJackpotPlayer);
